import React from 'react';

const ProductPreviewModal = ({ isOpen, onClose, product }) => {
  if (!isOpen || !product) return null;
  const displayPrice = String(product.price ?? '').replace(/\$/g, '₹');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" style={{boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'}}>
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-stone-200">
          <h2 className="text-2xl font-bold" style={{color: '#3E3E3E'}}>Product Details</h2>
          <button
            onClick={onClose}
            className="text-stone-400 hover:text-stone-600 transition-colors"
          >
            <span className="material-symbols-outlined text-2xl">close</span>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Image — full photo visible (letterboxed) */}
            <div className="flex min-h-[200px] max-h-[85vh] w-full items-center justify-center overflow-hidden rounded-xl bg-stone-900 p-2 sm:p-4">
              <img
                src={product.image}
                alt={product.name}
                className="max-h-[min(80vh,800px)] w-full max-w-full object-contain"
              />
            </div>

            {/* Product Info */}
            <div className="flex flex-col justify-center space-y-6">
              <div>
                <h3 className="text-3xl font-bold mb-2" style={{color: '#3E3E3E'}}>
                  {product.name}
                </h3>
                <p className="text-4xl font-bold" style={{color: '#C8A96A'}}>
                  {displayPrice}
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold mb-2" style={{color: '#3E3E3E'}}>
                  Description
                </h4>
                <p className="text-stone-600 leading-relaxed">
                  {product.description}
                </p>
              </div>

              {/* Product Features */}
              <div>
                <h4 className="text-lg font-semibold mb-3" style={{color: '#3E3E3E'}}>
                  Key Features
                </h4>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2 text-stone-600">
                    <span className="material-symbols-outlined text-sm" style={{color: '#C8A96A'}}>
                      check_circle
                    </span>
                    <span>Premium quality materials</span>
                  </li>
                  <li className="flex items-center gap-2 text-stone-600">
                    <span className="material-symbols-outlined text-sm" style={{color: '#C8A96A'}}>
                      check_circle
                    </span>
                    <span>Handcrafted excellence</span>
                  </li>
                  <li className="flex items-center gap-2 text-stone-600">
                    <span className="material-symbols-outlined text-sm" style={{color: '#C8A96A'}}>
                      check_circle
                    </span>
                    <span>Sustainable design</span>
                  </li>
                  <li className="flex items-center gap-2 text-stone-600">
                    <span className="material-symbols-outlined text-sm" style={{color: '#C8A96A'}}>
                      check_circle
                    </span>
                    <span>Lifetime warranty</span>
                  </li>
                </ul>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-4">
                <button
                  className="flex-1 px-6 py-3 rounded-full font-medium transition-all duration-300 text-white hover:scale-105"
                  style={{backgroundColor: '#C8A96A'}}
                >
                  <span className="flex items-center justify-center gap-2">
                    <span className="material-symbols-outlined">shopping_cart</span>
                    Add to Cart
                  </span>
                </button>
                <button
                  className="px-6 py-3 rounded-full font-medium border border-stone-300 text-stone-700 hover:bg-stone-50 transition-colors"
                >
                  <span className="flex items-center justify-center gap-2">
                    <span className="material-symbols-outlined">favorite_border</span>
                    Save
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPreviewModal;
